<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
  <p>{{data.text}}</p>
</div>
<div mat-dialog-actions>
  <button *ngIf="!data.buttonText || !data.buttonUrl" mat-button (click)="onOkClick()">OK</button>
  <a *ngIf="data.buttonText && data.buttonUrl" mat-button href="{{data.buttonUrl}}">{{data.buttonText}}</a>
</div>
